// queries/querySiteData.ts
// Every collection the home page (plus the always-mounted Hero/Footer social
// icons) needs, combined into one GraphQL query so the app makes a single
// request instead of one per section.
export const querySiteData = (preview: boolean = false) => `query{
    generalInformationInTheResumeCollection(
      order:[date_DESC]
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        name
        date
        company
        location
        singlePostText
        url
        image {
          title
          description
          contentType
          fileName
          size
          url
          width
          height
        }
        highlighted
      }
    }
    informationAboutStudiesInTheCurriculumCollection(
      order:[date_DESC]
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        name
        date
        institute
        location
        singlePostText
        url
        image {
          title
          description
          contentType
          fileName
          size
          url
          width
          height
        }
        highlighted
      }
    }
    informationAboutLicensesAndCertificationsCollection(
      order:[date_DESC]
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        name
        date
        institute
        location
        singlePostText
        url
        image {
          title
          description
          contentType
          fileName
          size
          url
          width
          height
        }
        highlighted
      }
    }
    vtexTrainingCollection(
      order:[date_DESC]
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        name
        date
        institute
        location
        singlePostText
        url
        image {
          title
          description
          contentType
          fileName
          size
          url
          width
          height
        }
        highlighted
      }
    }
    skillsGlobesCollection(
      order:[name_DESC]
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        name
        percentage
        color
      }
    }
    knowledgeCollection(
      order:[item_DESC]
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        item
      }
    }
    servicesCollection(
      preview: ${preview}
      limit: 10
    ){
      items{
        sys{
          id
        }
        title
        showSection
        servicesCollection{
          items{
            sys{
              id
            }
            serviceName
            serviceIcon{
              title
              url
            }
            serviceDescription
            currency
            amount
            period
            buttonText
            buttonUrl
            buttonTarget
            showButton
          }
        }
      }
    }
    socialMediaIconsCollection(
      order:[title_DESC]
      preview: ${preview}
      limit: 10
    ){
      items{
        sys{
          id
        }
        iconsCollection{
          items{
            sys{
              id
            }
            title
            url
            icon{
              url
            }
          }
        }
      }
    }
    badgesCollection(
      preview: ${preview}
      limit: 5
    ){
      items{
        sys{
          id
        }
        name
        badgeUrl
        badgeImage{
          title
          description
          url
        }
        badgePdf{
          title
          description
          url
        }
      }
    }
    downloadCvCollection(
      preview: ${preview}
    ){
      items{
        sys{
          id
        }
        title
        file{
          url
        }
      }
    }
  }`;
